import { render, staticRenderFns } from "./disableAccount.vue?vue&type=template&id=f1db8426&scoped=true&"
import script from "./disableAccount.vue?vue&type=script&lang=js&"
export * from "./disableAccount.vue?vue&type=script&lang=js&"
import style0 from "./disableAccount.vue?vue&type=style&index=0&id=f1db8426&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1db8426",
  null
  
)

export default component.exports